import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BlocErreur } from '../ImportAll'

class ListingAlerts extends Component {
    render() {
        if (this.props.ListingAlertsObject) {
            const content = this.props.ListingAlertsObject.map((key) => (
                <BlocErreur key={key} id={key} label={key} />
            ))
            return <div>{content}</div>
        }
        return null
    }
}

const mapStateToProps = (state, ownProps) => {
    if (state.answer[ownProps.linked_list_id]) {
        return {
            ListingAlertsObject: state.answer[ownProps.linked_list_id],
        }
    }
    return {}
}

export default connect(mapStateToProps)(ListingAlerts)
